var _a, _b, _c;
import { __decorate, __metadata, __param } from "tslib";
import { OpenService } from '@patsnap/tahiti-core';
import { inject, injectable } from 'inversify';
import { PageSelectorServiceSymbol } from '@/presentation/components/page-selector/PageSelectorService';
import { RequestExportPaperOptionsService } from './services/request-export-paper-options-service';
import { ExportPaperService } from './services/export-paper-service';
import { ANALYTICS_URI } from 'library-@/config/apiConfig';
let ExportPaperCommandContribution = class ExportPaperCommandContribution {
    // eslint-disable-next-line max-params
    constructor(_requestExportPaperOptionsService, _pageSelectorService, _exportPaperService, _openService) {
        this._requestExportPaperOptionsService = _requestExportPaperOptionsService;
        this._pageSelectorService = _pageSelectorService;
        this._exportPaperService = _exportPaperService;
        this._openService = _openService;
    }
    registerCommands(registry) {
        registry.registerCommand({
            id: 'export-papers',
        }, {
            execute: async () => {
                const selectedCount = this._pageSelectorService.selectedCount;
                this._requestExportPaperOptionsService.onSubmit(async (exportPaperOptions, next) => {
                    const taskId = await this._exportPaperService.exportPapers(exportPaperOptions);
                    this._openService.open(`${ANALYTICS_URI}/export/result/${taskId}`);
                    next();
                });
                return this._requestExportPaperOptionsService.open({
                    selectedCount,
                });
            },
        });
    }
};
ExportPaperCommandContribution = __decorate([
    injectable(),
    __param(0, inject(RequestExportPaperOptionsService)),
    __param(1, inject(PageSelectorServiceSymbol)),
    __param(2, inject(ExportPaperService)),
    __param(3, inject(OpenService)),
    __metadata("design:paramtypes", [typeof (_a = typeof RequestExportPaperOptionsService !== "undefined" && RequestExportPaperOptionsService) === "function" ? _a : Object, Object, typeof (_b = typeof ExportPaperService !== "undefined" && ExportPaperService) === "function" ? _b : Object, typeof (_c = typeof OpenService !== "undefined" && OpenService) === "function" ? _c : Object])
], ExportPaperCommandContribution);
export { ExportPaperCommandContribution };
